module.exports = __webpack_public_path__ + "static/6-40be323c6f00388c60a6d13b88f06479.jpg";